<template>
  <div id="app">
    <router-view />
  </div>
</template>
<script>
import HeaderNav from './components/PCComponents/HeaderNav'
import Footer from './components/PCComponents/Footer'
export default {
  name: 'App',
  components: {
    HeaderNav, Footer
  },
  computed: {
    media() {
      const path = this.$route.path;
      return path.indexOf('PC') >= 0 ? 'PC' : 'Mobile';
    }
  }
}
</script>
<style lang="less">

body {
  margin: 0;
  color: #2e2e2e;
  font-family: 'Arial';
  * {
    box-sizing: border-box;
    margin: 0;
    padding: 0;
  }
}
</style>
